import { Group } from '@mantine/core';
import { UseFormWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { technologicalTransferPartnerTypes } from '@/module/Author/TechnologicalTransfer';
import { TechnologicalTransferSchema } from '@/module/Author/TechnologicalTransfer/model/TechnologicalTransferSchema';

import { EnumSelectControl, TextInputControl } from '@/core/components';

export interface TechnologicalTransferPartnerTypeSelectControlProps {
  isSubmitting: boolean;
  watch: UseFormWatch<TechnologicalTransferSchema>;
}

export const TechnologicalTransferPartnerTypeSelectControl = (
  props: TechnologicalTransferPartnerTypeSelectControlProps,
) => {
  const { isSubmitting, watch } = props;
  const { t } = useTranslation();

  const partnerTypeField = watch('partnerType');
  const showPartnerTypeNameField = partnerTypeField === 'OTHER';

  return (
    <Group>
      <EnumSelectControl<TechnologicalTransferSchema>
        withAsterisk
        name="partnerType"
        label={t('technologicalTransfers.form.fields.partnerType')}
        isSubmitting={isSubmitting}
        options={technologicalTransferPartnerTypes.map(type => ({
          value: type,
          label: t(`technologicalTransfers.partnerTypeEnum.${type}`),
        }))}
      />
      {showPartnerTypeNameField && (
        <TextInputControl<TechnologicalTransferSchema>
          withAsterisk
          name="partnerTypeName"
          label={t('technologicalTransfers.form.fields.partnerTypeName')}
          isSubmitting={isSubmitting}
        />
      )}
    </Group>
  );
};
